import REDUX_DOMAIN from '../../constants/domain'
import getClassNameReduxUtil from '../get-class-name'
import { getIdReduxUtil } from '../get-id'
import getPathFromDomainPathReduxUtil from '../get-path-from-domain-path'

export function getPathReduxUtil (instance) {
  if (!instance) {
    return ''
  }

  const domainPath = REDUX_DOMAIN[getClassNameReduxUtil(instance)]
  if (!domainPath) {
    return ''
  }

  const id = getIdReduxUtil(instance)
  return getPathFromDomainPathReduxUtil(domainPath, id)
}
